import { InitializeApi } from "@ifgengineering/client-invest-sdk";
import { CUR8_SERVER } from "gatsby-env-variables";
import axios from "axios";

export const clientInvestSdk = InitializeApi({
  serverURL: CUR8_SERVER,
  appAxios: axios,
});
